import CdLoading from './loading.vue'

// CdButton.install = function (Vue) {
//     Vue.component(CdButton.name, CdButton)
// }

export default CdLoading